module.exports = __webpack_public_path__ + "static/media/064-lithuania.49457038.svg";